import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import apiClient from '../api/client';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const searchParams = new URLSearchParams(location.search);
  const successMessage = location.state?.message;
  const inactivityMessage = searchParams.get('reason') === 'inactivity' ? t('loggedOutDueToInactivity') : null;
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await apiClient.post('/auth/login', formData);
      
      if (res.data.requires2FA) {
        const redirect = new URLSearchParams(location.search).get('redirect');
        navigate('/login-2fa', {
          state: {
            email: formData.email,
            password: formData.password,
            redirect: redirect || undefined
          }
        });
        return;
      }
      
      localStorage.setItem('token', res.data.token);
      const redirect = new URLSearchParams(location.search).get('redirect');
      const target = redirect && redirect.startsWith('/') ? redirect : '/';
      window.location.href = target;
    } catch (err) {
      setError(err.response?.data?.error || t('loginError'));
    }
  };

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>{t('loginTitle')}</h1>
        
        {successMessage && <div className="success">{successMessage}</div>}
        {inactivityMessage && <div className="success">{inactivityMessage}</div>}
        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t('email')}
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            className="input"
          />
          <input
            type="password"
            placeholder={t('password')}
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required
            className="input"
          />
          <div className="auth-forgot-link">
            <Link to="/forgot-password">{t('forgotPasswordLink')}</Link>
          </div>
          <button type="submit" className="btn btn-primary">
            {t('login')}
          </button>
        </form>

        <div className="auth-divider">
          <span className="divider-line"></span>
          <span className="divider-text">{t('or')}</span>
          <span className="divider-line"></span>
        </div>

        <Link to="/register" className="btn btn-secondary">
          {t('register')}
        </Link>
      </div>
    </div>
  );
}

export default Login;
